import { motion } from 'framer-motion';
import DashboardLayout from '../../components/layout/DashboardLayout';
import BudgetTracker from './components/BudgetTracker';
import './FinancesPage.css';

const FinancesPage = () => {
  return (
    <DashboardLayout>
      <div className="finances-container">
        <motion.div 
          className="page-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1>Finances</h1>
          <p>Track your financial goals</p>
        </motion.div>
        <BudgetTracker />
      </div>
    </DashboardLayout>
  );
};

export default FinancesPage; 